/**
 *
 * @param value
 * @returns {string|number}
 */
export const getTotalCount = (value) => {
  if (!Number.isInteger(value) || value < 1000) return value
  return `${(value / 1000).toFixed(1)}k`
}

export const getTotalLikes = ({ likes_total = 0, halowaypoint_likes = 0 } = {}) => likes_total + halowaypoint_likes
